module.exports = __webpack_public_path__ + "static/media/lsa.715e5877.png";